import { tryToPromise } from "../../shared.js";
import { AuthProviderIdentifier } from "../AuthProviderIdentifier.js";
import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../data/LoginData.js";
import { debug } from "../LoginDbg.js";
import { LoginProvider } from "./LoginProvider.js";
import { OneTapDelegate } from "./OneTapDelegate.js";
import { ProviderHasOneTapDelegate } from "./ProviderHasDelegate.js";



const INTERNAL_PROVIDER_ID = AuthProviderIdentifier.GOOGLE_ONE_TAP;




class GoogleLoginOneTapDelegate implements LoginProvider, ProviderHasOneTapDelegate {

   
    constructor(
                public readonly client_id: string,
                private oneTapDelegate: OneTapDelegate = null
    ) {

        
    }
    preloadAction(): Promise<void> {
        return Promise.resolve();
    }
    

    setOneTapDelegate(newDelegate: OneTapDelegate) {
        this.oneTapDelegate = newDelegate;
    }



    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {
       
        return Promise.reject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "Not Unsupported"));

    }
    promptLogin(): Promise<ThirdPartyCientAuthData> {
        return this.oneTapLogin();
    }

    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return this.oneTapDelegate.oneTapDelegateLogin().then(resp => {
            debug.write("Received Response from delegate", resp);
            if(resp.credential) {
                let extraData: any = null;
                if(resp.select_by === "auto" || resp.select_by === "fedcm_auto") {
                    extraData = {
                        oneTapAutoSelect: true
                    };
                }   
                return tryToPromise(
                    () => { 
                        return new ThirdPartyCientAuthData(
                            null,
                            new ActualDataTuple(
                                this.providerId,
                                "", 
                                resp.credential,
                                null,
                                null
                            ),
                            extraData
                        );
                    }
                );
            }
            return Promise.reject("Not fully handled");
        });
        
    }
    
    niceName: string = "GoogleOneTap";
    supportsAutoLogin: boolean = false;
    useOwnLoginPrompt: boolean = true;
    providerId: AuthProviderIdentifier = INTERNAL_PROVIDER_ID;
    supportsOneTap: boolean = true;


    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        return this.oneTapDelegate.oneTapDelegateRevoke(hint, isDeleteRequest);
    }

}


export { GoogleLoginOneTapDelegate };
